export default __webpack_public_path__ + "media/images/psa-logo-6361979ab3cb5d799f4f8aaa3ce1acec.png";